"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var go_1 = require("react-icons/go");
var constant_1 = require("../../../constant");
var style_1 = require("../../../style");
var icons_1 = require("../../../icons");
var _1 = require("./");
var styles_1 = require("./styles");
var ControlLabel_1 = __importDefault(require("../../Common/ControlLabel"));
var layout_1 = require("../../layout");
var White = style_1.SixsenseColor.White;
var Icon = function (_a) {
    var checked = _a.checked, error = _a.error, disabled = _a.disabled, checkedIndicator = _a.checkedIndicator;
    var theme = react_1.useTheme();
    var styles = react_2.useMemo(function () { return styles_1.getRadioButtonIconStyles(theme); }, [theme]);
    var iconStyle = react_2.useMemo(function () { return [
        styles.container,
        checked ? styles.checkedContainer : undefined,
        error ? styles.errorContainer : undefined,
        disabled ? styles_1.getDisabledIconStyle(checked, theme.name) : undefined,
    ]; }, [styles, checked, error, disabled, theme.name]);
    var icon = null;
    if (checked) {
        icon = theme.name === constant_1.DESIGN_SYSTEM
            ? checkedIndicator === 'circle'
                ? react_1.jsx(icons_1.Circle, { size: '0.375rem', color: White.DEFAULT })
                : react_1.jsx(icons_1.Check, { strokeWidth: 1.5, size: 10, color: White.DEFAULT })
            : react_1.jsx(go_1.GoPrimitiveDot, { css: { height: style_1.pxToRem(16), width: style_1.pxToRem(16) } });
    }
    return react_1.jsx("span", { css: iconStyle, className: "icon" }, icon);
};
var RadioButton = function (_a) {
    var _b;
    var _c = _a.labelPosition, labelPosition = _c === void 0 ? 'after' : _c, disabled = _a.disabled, error = _a.error, value = _a.value, _d = _a.checkedIndicator, checkedIndicator = _d === void 0 ? 'circle' : _d, label = _a.label, subLabel = _a.subLabel;
    var radioGroupContext = react_2.useContext(_1.RadioGroupContext);
    var theme = react_1.useTheme();
    var styles = react_2.useMemo(function () { return styles_1.getRadioButtonIconStyles(theme); }, [theme]);
    return (react_1.jsx(layout_1.Flex, { css: !disabled && ((_b = styles.root) === null || _b === void 0 ? void 0 : _b.call(styles, value === radioGroupContext.value)) },
        react_1.jsx(ControlLabel_1.default, { label: label, subLabel: subLabel, labelPosition: labelPosition },
            react_1.jsx("input", { css: styles_1.inputStyle, type: "radio", checked: value === radioGroupContext.value, disabled: disabled, value: value, onChange: function (e) {
                    if (radioGroupContext.onChange) {
                        radioGroupContext.onChange(e.target.value);
                    }
                } }),
            react_1.jsx(Icon, { checked: value === radioGroupContext.value, checkedIndicator: checkedIndicator, disabled: disabled, error: error }))));
};
exports.default = RadioButton;
